import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dateInput", "dateLabel", "weekdayLabel", "body"]

  connect() {
    document.addEventListener("turbo:load", this._boundLoad = () => this._load())
    this._boundPop = () => this._load()
    window.addEventListener("popstate", this._boundPop)
    this._load()
  }

  disconnect() {
    document.removeEventListener("turbo:load", this._boundLoad)
    window.removeEventListener("popstate", this._boundPop)
  }

  _load() {
    const params = new URLSearchParams(window.location.search)
    const dateParam = params.get("date")
    this.currentDate = dateParam ? new Date(dateParam + "T12:00:00") : new Date()
    this._update()
  }

  prev() {
    this.currentDate.setDate(this.currentDate.getDate() - 1)
    this._pushURL()
    this._update()
  }

  next() {
    this.currentDate.setDate(this.currentDate.getDate() + 1)
    this._pushURL()
    this._update()
  }

  today() {
    this.currentDate = new Date()
    this._pushURL()
    this._update()
  }

  openDatePicker() {
    this.dateInputTarget.showPicker()
  }

  dateChanged() {
    const val = this.dateInputTarget.value
    if (val) {
      this.currentDate = new Date(val + "T12:00:00")
      this._pushURL()
      this._update()
    }
  }

  _pushURL() {
    const dateStr = this.currentDate.toISOString().split("T")[0]
    const url = new URL(window.location)
    url.searchParams.set("date", dateStr)
    history.pushState(history.state, "", url)
  }

  _update() {
    const controller = this
    const dateStr = this.currentDate.toISOString().split("T")[0]
    this.dateInputTarget.value = dateStr

    const d = new Date(parseInt(dateStr.split("-")[0]), parseInt(dateStr.split("-")[1]) - 1, parseInt(dateStr.split("-")[2]))
    const dayNames = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"]
    const monthNames = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
    this.dateLabelTarget.textContent = `${d.getDate()} de ${monthNames[d.getMonth()]} de ${d.getFullYear()}`
    this.weekdayLabelTarget.textContent = dayNames[d.getDay()]

    fetch(`/agenda?date=${dateStr}`, {
      headers: { Accept: "application/json" }
    })
    .then(r => r.json())
    .then(matches => {
      controller.bodyTarget.innerHTML = controller.renderMatches(matches)
    })
  }

  flagWrap(flag) {
    return `<span class="agenda-team-flag">${flag || "🏳"}</span>`
  }

  renderMatches(matches) {
    if (matches.length === 0) {
      return `<div class="agenda-empty">Nenhuma partida neste dia</div>`
    }

    return matches.map(m => {
      const homeFlag = this.flagWrap(m.home_flag)
      const awayFlag = this.flagWrap(m.away_flag)

      const t = new Date(m.match_date)
      const timeStr = t.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })

      let statusAbbr = ""
      if (m.status === "finished") {
        statusAbbr = `<span class="agenda-status agenda-status-finished">FT</span>`
      } else if (m.status === "live") {
        statusAbbr = `<span class="agenda-status agenda-status-live">🔴</span>`
      }

      const statusHtml = `${timeStr}${statusAbbr ? `<br>${statusAbbr}` : ""}`

      const url = `/matches/${m.id}`
      const homeScore = m.home_score != null ? m.home_score : "-"
      const awayScore = m.away_score != null ? m.away_score : "-"

      let actionHtml
      if (m.status === "finished" && m.has_won) {
        const prize = (m.guess_points / 100).toFixed(2)
        actionHtml = `<span class="agenda-action-wrap"><span class="agenda-action agenda-action-won"><i class="fa-solid fa-trophy"></i></span><span class="agenda-tt">Ganhou ZR$ ${prize}</span></span>`
      } else if (!m.started) {
        if (m.guess_count > 0) {
          actionHtml = `<span class="agenda-action-wrap"><span class="agenda-action agenda-action-guessed">${m.guess_count} <i class="fa-regular fa-futbol"></i></span><span class="agenda-tt">Você fez ${m.guess_count} palpite${m.guess_count > 1 ? "s" : ""} nessa partida</span></span>`
        } else {
          actionHtml = `<span class="agenda-action-wrap"><span class="agenda-action agenda-action-pending"><i class="fa-regular fa-hand-pointer"></i></span><span class="agenda-tt">Faça seu palpite nessa partida</span></span>`
        }
      }

      return `
        <a href="${url}" class="agenda-match" data-turbo-action="advance">
          <div class="agenda-col-status">${statusHtml}</div>
          <div class="agenda-col-teams">
            <div class="agenda-team">${homeFlag} ${m.home_name}</div>
            <div class="agenda-team">${awayFlag} ${m.away_name}</div>
          </div>
          <div class="agenda-col-right">
            ${actionHtml ? `<div class="agenda-col-action">${actionHtml}</div>` : ""}
            <div class="agenda-col-scores" style="font-family:var(--font-mono)">
              <div class="agenda-score">${homeScore}</div>
              <div class="agenda-score">${awayScore}</div>
            </div>
          </div>
        </a>
      `
    }).join("")
  }
}
